import { useEffect, useState, useContext } from "react";
import "./OneCandidate.css";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import PreviousRound from "../previousround/PreviousRound";
import candidateImg from "../../assests/candidateImg.png";
import candidateCV from "../../assests/candidateCV.png";
import { Space, Divider, Image, Typography } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
const { Text } = Typography;

export default function OneCandidate({ id, lno, onBack }) {
    const { authData, backUrl } = useContext(AuthContext);
    const [singleData, setSingleData] = useState({});
    const [data, setData] = useState({
        level_number: lno,
        status: '',
        remarks: '',
    });

    const [viewPrevious, setViewPrevious] = useState(false)

    const [techAssessment, setTechAssessment] = useState({
        tech_qualification: '',
        tech_experience: '',
        tech_knowledge: '',
        tech_skills_rating: '',
        tech_attitude: '',
        tech_communication: '',
        tech_time_management: '',
        tech_flexibility: '',
        tech_commitment: '',
    });

    const [previous, setPrevious] = useState([])

    const handleGetOne = async () => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/candidates/all_interview_levels/?candidate_id=${id}`,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );
            setSingleData(res.data);

            // Extract current level's assessment
            const currentLevel = res.data.interview_levels.find(
                (lvl) => lvl.level_number === lno
            );

            if (currentLevel) {
                setTechAssessment({
                    tech_qualification: currentLevel.tech_qualification || '',
                    tech_experience: currentLevel.tech_experience || '',
                    tech_knowledge: currentLevel.tech_knowledge || '',
                    tech_skills_rating: currentLevel.tech_skills_rating || '',
                    tech_attitude: currentLevel.tech_attitude || '',
                    tech_communication: currentLevel.tech_communication || '',
                    tech_time_management: currentLevel.tech_time_management || '',
                    tech_flexibility: currentLevel.tech_flexibility || '',
                    tech_commitment: currentLevel.tech_commitment || '',
                });

                setData((prev) => ({
                    ...prev,
                    status: currentLevel.status || '',
                    remarks: currentLevel.remarks || '',
                }));
            }
        } catch (err) {
            console.error("Error fetching candidate details:", err);
        }
    };



    const handleFeedback = async () => {
        try {
            const finalPayload = {
                ...data,
                ...techAssessment,
            };

            const res = await axios.put(
                `${backUrl}/api/emp/candidates/${id}/hod_review/`,
                finalPayload,
                { headers: { Authorization: `Bearer ${authData?.access}` } }
            );


            if (data.status === "Shortlisted") {
                toast.success("Candidate Shortlisted")
            }
            else if (data.status === "Rejected") {
                toast.warning("Candidate Rejected")
            }
            else {
                toast.warning("Candidate in hold")
            }


        } catch (error) {
            console.error("Error submitting feedback:", error);
            toast.error("Failed to submit feedback.");
        }
    };


    useEffect(() => {
        if (id) handleGetOne();
    }, [id]);

    const personalFields = [
        { label: "Candidate Name", key: "candidate_name" },
        // { label: "Position", key: "position" },
        // { label: "Location", key: "location" },
        { label: "Mobile Number", key: "mobile_number" },
        { label: "Email Id", key: "email_id" },
        { label: "Aadhaar", key: "aadhaar" },
        { label: "Pan", key: "pan" },
        { label: "Address", key: "address", type: "textarea" },
        { label: "City", key: "city" },
        { label: "State", key: "state" },
        { label: "Pincode", key: "pincode" }
    ];

    const professionalFields = [
        { label: "Education Background", key: "education_background", type: "textarea" },
        { label: "Technical Background", key: "technical_background", type: "textarea" },
        { label: "Relevant Experience", key: "relevant_experience" },
        { label: "Total Experience", key: "total_experience" },
        { label: "Specification", key: "specification" },
        { label: "Present Salary", key: "present_salary" },
        { label: "Expected Salary", key: "expected_salary" },
        { label: "Notice Period", key: "notice_period" }
    ];


    const TechAssessment = () => {
        const options = ["Excellent", "Acceptable", "Average", "Below Average", "Poor"];

        const renderRadioGroup = (label, field) => (
            <div className="mb-4 d-flex flex-column align-items-start justify-content-between">
                {/* Label on the left */}
                <label className="form-label fw-bold mb-0" style={{ minWidth: "200px", textTransform: 'uppercase' }}>
                    {label}
                </label>

                {/* Options on the right */}
                <div id="tect-assessment-item" className="d-flex flex-wrap justify-content-around gap-3">
                    {options.map((option) => (
                        <label
                            key={option}
                            className="d-flex align-items-center"
                            style={{ cursor: "pointer", fontSize: '14px', fontWeight: 'normal' }}
                        >
                            <input
                                type="radio"
                                name={field}
                                value={option}
                                checked={techAssessment[field] === option}
                                onChange={() =>
                                    setTechAssessment((prev) => ({ ...prev, [field]: option }))
                                }
                                className="form-check-input me-1"
                            // style={{fontWeight:'lighter'}}
                            />
                            {option}
                        </label>
                    ))}
                </div>
            </div>
        );

        return (
            <>
                <div className="tech-assessment-section mt-4">
                    {authData.employee.is_superuser ? (
                        <h5>HR Assessment</h5>
                    ) : (
                        <h5 className="mb-4">Technical Assessment</h5>

                    )}
                    {renderRadioGroup("Qualification", "tech_qualification")}
                    {renderRadioGroup("Experience", "tech_experience")}
                    {renderRadioGroup("Knowledge", "tech_knowledge")}
                    {renderRadioGroup("Skills", "tech_skills_rating")}
                    {renderRadioGroup("Attitude", "tech_attitude")}
                    {renderRadioGroup("Communication", "tech_communication")}
                    {renderRadioGroup("Time Management", "tech_time_management")}
                    {renderRadioGroup("Flexibility", "tech_flexibility")}
                    {renderRadioGroup("Commitment", "tech_commitment")}
                </div>
            </>
        );
    };


    const handlePrevious = async () => {
        try {
            const int_data = singleData.interview_levels;

            const filtered = await int_data.filter((item) => item.level_number !== lno);

            if (filtered.length === 0) {
                alert("There is no Previous round for this candidate!");
                return;
            }

            // console.log("singleData", singleData)

            setPrevious(filtered);
            setViewPrevious(true);
        } catch (error) {
            console.error("Error fetching interview levels:", error);
        }
    };

    const handleBack = () => setViewPrevious(false);





    return (
        <div className="d-flex flex-column candidate-details-wrapper">
            <ToastContainer position="top-right" autoClose={3000} />
            {
                viewPrevious === false ? (
                    <>
                        <div id="bread-container">
                            <a className="bread-anchor" id="bread-acr" onClick={onBack}>← Back</a>
                            <span className="no-anchor"> / </span>

                            <a className="bread-anchor" id="bread-acr" onClick={() => handlePrevious(id)}>Other Rounds</a>


                        </div>
                        <div className="card m-3 p-3">
                            <h5>Candidate Profile</h5>
                            <h6>Candidate for {singleData.designation} role</h6>
                            <div className="d-flex justify-content-around mt-5">

                                <Space size="large" direction="horizontal" style={{ justifyContent: "center", display: "flex", marginTop: 32 }}>
                                    {/* Candidate Image */}
                                    <div style={{ textAlign: "center", cursor: "pointer" }}
                                        onClick={async () => {
                                            try {
                                                const res = await fetch(`${singleData.candidate_photo}`);
                                                const blob = await res.blob();
                                                const fileURL = window.URL.createObjectURL(blob);
                                                window.open(fileURL, "_blank");
                                            } catch (error) {
                                                console.error("Error fetching photo:", error);
                                            }
                                        }}
                                    >
                                        <Image
                                            src={`${singleData.candidate_photo}`}
                                            alt="Candidate"
                                            width={150}
                                            height={150}
                                            style={{ borderRadius: "50%", objectFit: "cover" }}
                                            preview={false}
                                        />
                                    </div>

                                    <div
                                        style={{ textAlign: "center", cursor: "pointer" }}
                                        onClick={() => {
                                            window.open(singleData.candidate_cv, "_blank", "noopener,noreferrer");
                                        }}
                                    >
                                        <Image
                                            src={candidateCV}
                                            alt="Resume"
                                            width={30}
                                            height={30}
                                            preview={false}
                                        />
                                        <Text style={{ display: "block", marginTop: 8 }}>Resume</Text>
                                    </div>
                                </Space>

                            </div>
                            <Divider />
                            <div className="d-flex justify-content-between gap-4 flex-wrap">
                                <div className="flex-fill" style={{ minWidth: "300px" }}>
                                    {[
                                        "Candidate Name", "Mobile number",
                                        "Email Id", "Aadhaar", "Pan", "Address",
                                        "City", "State", "Pincode"
                                    ].map((label, idx) => (
                                        <div key={idx} className="mb-2">
                                            <label>{label}</label>
                                            {label === "Address" ? (
                                                <textarea className="form-control" value={singleData[label.toLowerCase().replace(/ /g, '_')]} readOnly />
                                            ) : (
                                                <input type="text" className="form-control" value={singleData[label.toLowerCase().replace(/ /g, '_')]} readOnly />
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <div className="flex-fill" style={{ minWidth: "300px" }}>
                                    {[
                                        "Education Background",
                                        "Technical Background",
                                        "Relevant Experience",
                                        "Total Experience",
                                        "Specification",
                                        "Present Salary",
                                        "Expected Salary",
                                        "Notice Period"
                                    ].map((label, idx) => {
                                        let value = singleData[label.toLowerCase().replace(/ /g, "_")];

                                        // round salary values only
                                        if (label === "Present Salary" || label === "Expected Salary") {
                                            value = value != null && value !== ""
                                                ? Number(value).toFixed(0)   // <-- ensures integer output
                                                : "";
                                        }

                                        return (
                                            <div key={idx} className="mb-2">
                                                <label>{label}</label>
                                                {label.includes("Background") ? (
                                                    <textarea className="form-control" value={value} readOnly />
                                                ) : (
                                                    <input className="form-control" value={value} readOnly />
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>


                            </div>

                            <hr />
                            <div className="interview-feedback-container p-4 rounded shadow-sm bg-light mt-3">

                                <TechAssessment />

                                <center><h5 className="mb-3">Interview Feedback</h5></center>
                                <div className="mb-3 d-flex flex-wrap gap-2">
                                    <button
                                        className={`btn ${data.status === 'Shortlisted' ? 'btn-success' : 'btn-outline-success'}`}
                                        onClick={() => setData({ ...data, status: 'Shortlisted' })}
                                    >
                                        Shortlist
                                    </button>
                                    <button
                                        className={`btn ${data.status === 'Rejected' ? 'btn-danger' : 'btn-outline-danger'}`}
                                        onClick={() => setData({ ...data, status: 'Rejected' })}
                                    >
                                        Rejected
                                    </button>

                                    <button
                                        className={`btn ${data.status === 'On-hold' ? 'btn-secondary' : 'btn-outline-secondary'}`}
                                        onClick={() => setData({ ...data, status: "On-hold" })}
                                    >
                                        Hold
                                    </button>
                                </div>

                                <div className="mb-3">
                                    <label className="form-label fw-bold">Remarks</label>
                                    <textarea
                                        className="form-control"
                                        name="remarks"
                                        rows="3"
                                        value={data.remarks}
                                        onChange={(e) => setData({ ...data, remarks: e.target.value })}
                                    />
                                </div>

                                <button onClick={handleFeedback} className="text-light p-2">
                                    Submit Feedback
                                </button>
                            </div>

                        </div>
                    </>
                ) : (
                    <>
                        <PreviousRound id={id} previous={previous} onBack={handleBack} />
                    </>
                )

            }
        </div>
    );
}
